import MobileDetect from 'mobile-detect';
import Provider from '../model/Provider';
import GlobalVal from '../model/GlobalVar'
import Config from '../model/Config';
import { viewEvent } from '../../gov/controller/viewEventCtrl';
import { mobile } from '../../gov/controller/mobileCtrl';

//세로모드 카카오웹브라우저 화면 넓이/높이
export var deviceWBKWitdh = "";
export var deviceWBKHeight = "";
export var isDevice_TB_WBK_Portrait = false;

export function isPC_TB_MO(){
	var deviceCode = "";   //PC/MO/TB
	const md = new MobileDetect(window.navigator.userAgent);
	if(md.mobile() != null){
		if(md.tablet() != null || md.match("SM-T")){
			deviceCode = "TB";
		}else{
			deviceCode = "MO";
		}
	}else{
		deviceCode = "PC";
	}
	return deviceCode;
}

export const device = {
	init(){
		//DeviceInfo 값 갱신
		device.setDeviceCode();
		device.checkMobileType();
		device.checkSpecialBrowser();
	},
	isExplorer: ()=>{
		if(window.navigator.userAgent.match("Trident") != null){
			return true;
		}else{
			return false;
		}
	},
	isFireFox: ()=>{
		if(window.navigator.userAgent.match("Firefox") != null){
			return true;
		}else{
			return false;
		}
	},
	setDeviceCode: ()=>{
		if(isPC_TB_MO() == "PC"){
			GlobalVal.pcMobileId = ".pcView"
			Provider.deviceInfo.code = "PC"
		}else if(isPC_TB_MO() == "TB"){
			GlobalVal.pcMobileId = ".pcView"
			Provider.deviceInfo.code = "TB"
		}else{
			GlobalVal.pcMobileId = ".mobileView"
			Provider.deviceInfo.code = "MO"
		}
	},
	setDeviceUniversalLink:()=>{
		Provider.deviceInfo.universalLink = Config.uriScheme.universalLink
	},
	checkMobileType:()=>{
		const varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
		if ( varUA.indexOf('android') > -1) {
		  //안드로이드
		  Provider.deviceInfo.os = "AOS";
			return "AOS";
		} else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
			//IOS
		  Provider.deviceInfo.os = "IOS";
			return "IOS";
		} else {
			//아이폰, 안드로이드 외
		  Provider.deviceInfo.os = "";
			return "";
		}
	},
	checkSpecialBrowser: () => {
		const varUA = navigator.userAgent.toLowerCase();
		if ( varUA.indexOf('kakaotalk') > -1) {
			//카카오인앱브라우저
			if(Provider.deviceInfo.browser == ""){
				Provider.deviceInfo.browser = "WBK";
			}
		}else {
			if(Provider.deviceInfo.browser == ""){
				Provider.deviceInfo.browser = "WB";
			}
		}
		return Provider.deviceInfo.browser;
	},
	portraitTBWidthSizeCheck: ()=>{
		//세로모드일 때 모바일 스크립트 실행
		if(window.matchMedia('(orientation: portrait)').matches) {
			//전체화면이 아닐 시 
			if(screen.width != $(window).width()){
				//세로모드 카카오웹브라우저 넓이
				deviceWBKWitdh = $(window).width();
				deviceWBKHeight = $(window).height();
				//테블릿 카카오웹, 세로형
				isDevice_TB_WBK_Portrait = true;
			}
		}else {
			//테블릿 카카오웹, 가로형
			isDevice_TB_WBK_Portrait = false;
		}
	},
	orientChangeTBProccesing: ()=>{
		$(window).off("orientationchange").on("orientationchange", function(e) { // 가로세로 전환 처리
			viewEvent.view_msg("안내","","화면 전환을 감지했습니다. 정상적인 간편인증을 위하여 화면 종료 후 다시 실행해 주시기 바랍니다.",viewEvent.closePopup);
		});
	},
	resizeTBProccesing: (fn)=>{
		deviceWBKWitdh = $(window).width();
		deviceWBKHeight = $(window).height();
		window.addEventListener('resize', function(){
			if($(window).width() === deviceWBKWitdh){
				return
			}
			if(screen.width == $(window).width() && $(window).width() !== deviceWBKWitdh){
				deviceWBKWitdh = $(window).width()
				fn()
				// alert(`전체 ${screen.width} | ${$(window).width()} | ${deviceWBKWitdh}`)
				return
			}else{
				deviceWBKWitdh = $(window).width()
				fn()
				// alert(`분할 ${screen.width} | ${$(window).width()} | ${deviceWBKWitdh}`);
				return
			}
		});
	},
	isMobile(){
		if(Provider.deviceInfo.code == "MO"){
			return true;
		}else{
			return false;
		}
	},
	isMobileUI: ()=>{
		if(Provider.deviceInfo.code == "MO"){
			GlobalVal.pcMobileId = ".mobileView"
			//MO
			return true;
		}else if(Provider.deviceInfo.code == "TB"){
			//TB - 카카오웹 일 때 화면모드가 세로형일 경우 모바일 UI
			if(Provider.deviceInfo.browser == "WBK"){
				if(isDevice_TB_WBK_Portrait){
					GlobalVal.pcMobileId = ".mobileView"
					return true;
				}
			}
			GlobalVal.pcMobileId = ".pcView"
			return false;
		}else{
			//PC
			GlobalVal.pcMobileId = ".pcView"
			return false;
		}
	}
} 